import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installTimezoneOffsetFetch } from './utils/timezoneOffset';
import { getIsMobileView } from './utils/mobile';

installTimezoneOffsetFetch();
document.documentElement.classList.toggle('mobile-device', getIsMobileView());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);